var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 48,
    viewBox: "0 0 53 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14487_22967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9528 48H6.04801C3.86546 48 1.91041 46.8592 0.818747 44.9495C-0.272916 43.039 -0.272916 40.7582 0.818747 38.8477L21.2715 3.05051C22.3632 1.1408 24.3174 0 26.5 0C28.6825 0 30.6376 1.1408 31.7285 3.05051L52.1813 38.8477C53.2729 40.7582 53.2729 43.039 52.1813 44.9495C51.0896 46.86 49.1345 48 46.952 48H46.9528ZM23.9828 4.63225L3.53005 40.4294C3.0044 41.349 3.0044 42.4474 3.53005 43.367C4.05569 44.2865 4.99673 44.8357 6.04801 44.8357H46.9528C48.004 44.8357 48.9451 44.2865 49.47 43.367C49.9956 42.4474 49.9956 41.349 49.47 40.4294L29.018 4.63225C28.4923 3.71271 27.5513 3.16349 26.5008 3.16349C25.4503 3.16349 24.5077 3.71271 23.9828 4.63225Z",
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5109 12.9575C28.7765 12.9575 30.5336 14.9575 30.2642 17.2312L28.6034 31.2653C28.4761 32.3417 27.5723 33.1522 26.4993 33.1522C25.4255 33.1522 24.5209 32.3402 24.3951 31.2621L22.7561 17.2249C22.4906 14.9535 24.2468 12.9575 26.5101 12.9575H26.5109Z",
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3684 39.9704C23.7861 39.3819 23.4941 38.6601 23.4941 37.8057C23.4941 36.9512 23.7853 36.2302 24.3684 35.641C24.9507 35.0525 25.665 34.7583 26.5106 34.7583C27.3561 34.7583 28.0697 35.0525 28.6528 35.641C29.2351 36.2294 29.5262 36.952 29.5262 37.8057C29.5262 38.6593 29.2351 39.3819 28.6528 39.9704C28.0704 40.5588 27.3553 40.8538 26.5106 40.8538C25.6658 40.8538 24.9515 40.5596 24.3684 39.9704Z",
    fill: "#FF8A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14487_22967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.9d03eb1a61f892277ca8474f237f01e4.svg";
export { ForwardRef as ReactComponent };